import icon1 from '@images/renders/architecture_images/icon1.svg';
import icon2 from '@images/renders/architecture_images/icon2.svg';
import icon3 from '@images/renders/architecture_images/icon3.svg';
import icon5 from '@images/renders/architecture_images/icon5.svg';
import icon6 from '@images/renders/architecture_images/icon6.svg';
import icon7 from '@images/renders/architecture_images/icon7.svg';
import icon8 from '@images/renders/architecture_images/icon8.svg';

export const visibleData = [
  {
    id: 1,
    icon: icon1,
    description: 'Устройство стяжки с&nbsp;шумоизоляцией',
  },
  {
    id: 2,
    icon: icon2,
    description: 'Устройство гидроизоляции в&nbsp;С/У, стяжки в&nbsp;С/У',
  },
  {
    id: 3,
    icon: icon3,
    description: 'Устройство системы механической централизованной системы вентиляции',
  },
  {
    id: 4,
    icon: icon5,
    description: 'Монтаж системы отопления, с&nbsp;установкой приборов отопления',
  },
  {
    id: 5,
    icon: icon6,
    description: 'Монтаж квартирного щита электроснабжения',
  },
  {
    id: 6,
    icon: icon7,
    description: 'Подготовка стен под финишную отделку',
  },
  {
    id: 7,
    icon: icon8,
    description: 'Выравнивание стен (кроме С/У)',
  },
];

export const hideData = [
  {
    id: 8,
    description: 'Возведение внутренних перегородок на&nbsp;всю высоту помещения',
  },
  {
    id: 9,
    description: 'Обеспыливание потолка',
  },
  {
    id: 10,
    description: 'Устройство точки подключения дренажной системы для внутренних блоков',
  },
  {
    id: 11,
    description: 'Установка автоматической пожарной сигнализации',
  },
  {
    id: 12,
    description: 'Ввод фреонопроводов под кондиционер',
  },
  {
    id: 13,
    description:
      'Разводка электрики от&nbsp;квартирного щита до&nbsp;места установки электроприборов, с&nbsp;установкой подрозетников',
  },
];

export const hideDataMobile = [
  {
    id: 8,
    description: 'Возведение внутренних перегородок на&nbsp;всю высоту помещения',
  },
  {
    id: 9,
    description: 'Установка автоматической пожарной сигнализации',
  },
  {
    id: 10,
    description: 'Обеспыливание потолка',
  },
  {
    id: 11,
    description: 'Ввод фреонопроводов под кондиционер',
  },
  {
    id: 12,
    description: 'Устройство точки подключения дренажной системы для внутренних блоков',
  },
  {
    id: 13,
    description:
      'Разводка электрики от&nbsp;квартирного щита до&nbsp;места установки электроприборов, с&nbsp;установкой подрозетников',
  },
];
